const rbac = {
  profiles: {
    QUERY_EXPORT_CRUD_GENERAL: 'QUERY_EXPORT_CRUD',
    QUERY_EXPORT_CRUD_MICRO: 'QUERY_EXPORT_CRUD_MICRO',

    QUERY_READ_OWN: 'QUERY_READ_OWN',
    WRULES_READER: 'WRULES_READER',
    WRULES_USER: 'WRULES_USER',
    WRULES_ADMIN: 'WRULES_ADMIN',
    WEBRESULTS_USER: 'WEBRESULTS_USER',
  },
  roles: { ADMIN: 'ADMIN', USER: 'USER' },
  appllications: {
    QUERY_BUILDER: 'QUERY_BUILDER',
    MULTICAST: 'MULTICAST',
    WEB_RESULTS: 'SISIFO',
  },
};
export { rbac };
